import React from 'react';
import ReactDOM from 'react-dom';
import MainPage from './components/MainPage';
import DictListwy from './components/DictListwy';
import Zlecenia from './components/Zlecenie/Zlecenia';
import StanListwy from './components/StanListwy/StanListwy';
import Login from './components/Login';
import Nav from './components/Nav';
import { Router, Route } from 'react-router-dom';
import { isLoggedIn } from './utils/AuthService';
import createBrowserHistory from "./components/history";

function Protected(Component) {
  return function (props) {
    if (!isLoggedIn()) {
      if (typeof window !== 'undefined') window.location.href = '/login';
      return null;
    }
    return <Component {...props} />;
  };
}

function NavWrapper() {
  if (typeof window !== 'undefined' && window.location.pathname === '/login') return null;
  return <Nav />;
}

class App extends React.Component {

  render() {

    return(
      <div className="container">
        <Router history={createBrowserHistory}>
          <div className="container">
            <Route component={NavWrapper}/>
            <Route path="/" exact component={MainPage}/>
            <Route path="/login" component={Login}/>
            <Route path="/zlecenie" component={Protected(Zlecenia)} />
            <Route path="/stanListwy" component={Protected(StanListwy)} />
            <Route path="/dictListwy" component={Protected(DictListwy)} />
          </div>
        </Router>
      </div>
    )
    }
  }

  ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js